import React, { createContext, useContext } from 'react';
import { Instance, types } from 'mobx-state-tree';

import room from './room';
import medal from './medal';
import users from './users';
import lianmai from './lianmai/index';

import guard from './guard';
import group from './group';
import topStars from './top-stars';
import performing from './performing';

// import marquee from '../components/marquee/store'
// import sofa from '../components/sofa/store'
// import recommend from '../components/live-recommend/store'
// import group from '../components/group-info/store'
// import fans from '../components/fans/store'

const RootModel = types
  .model('RootModel', {
    room: room.Model,
    medal: medal.Model,
    users: users.Model,
    guard: guard.Model,
    topStars: topStars.Model,
    // marquee: marquee.Model,
    // sofa: sofa.Model,
    // recommend: recommend.Model,
    group: group.Model,
    // fans: fans.Model,
    lianmai: lianmai.Model,
    performing: performing.Model,
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    return {};
  });

// export const rootStore = ;

let rootStore;

export const initStore = () => {
  // console.log('initStore rootStore', rootStore, '\r\nroomId:', allRoomInfo.room._id, '\r\nroomInfo:', allRoomInfo)
  const _rootStore =
    rootStore ??
    RootModel.create({
      room: room.initState,
      medal: medal.initState,
      users: users.initState,
      guard: guard.initState,
      topStars: topStars.initState,
      // marquee: marquee.initState,
      // sofa: sofa.initState,
      // recommend: recommend.initState,
      group: group.initState,
      // fans: fans.initState,
      lianmai: lianmai.initState,
      performing: performing.initState,
    });

  // console.log('init store', _rootStore)

  // if (state) {
  //   applySnapshot(_rootStore, state)
  // }
  if (typeof window !== 'undefined') {
    window.__store = _rootStore;
  }

  if (typeof window === 'undefined') return _rootStore;

  if (!rootStore) {
    rootStore = _rootStore;
    // onSnapshot(rootStore, snapshot => console.log("stage Snapshot: ", snapshot));
  }

  return rootStore;
};

export type RootInstance = Instance<typeof RootModel>;
const RootStoreContext = createContext<null | RootInstance>(null);

export const Provider = RootStoreContext.Provider;

export function useRoomStore() {
  const store = useContext(RootStoreContext);
  if (store === null) {
    throw new Error('Store cannot be null, please add a context provider');
  }
  return store;
}

/**
 * @deprecated 用 useClientRoomStore 替代, 更清晰
 */
export const useStore = useRoomStore;
export const useClientRoomStore = useRoomStore;

export const withStore = (Component) => {
  return (props) => {
    return (
      <Provider value={rootStore}>
        <Component {...props} />
      </Provider>
    );
  };
};

export function getStore() {
  return rootStore;
}
